import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Layout.css';

function Layout({ children }) {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="app-container">
      <nav className="navbar">
        <div className="nav-left">
          <div className="nav-brand">
            <Link to="/">Skiftrapport</Link>
          </div>
        </div>
        <div className="nav-user" ref={dropdownRef}>
          <button className="user-name-button" onClick={toggleDropdown}>
            {user?.fullName} ▼
          </button>
          {dropdownOpen && (
            <div className="user-dropdown">
              <Link to="/settings" onClick={() => setDropdownOpen(false)}>
                Innstillinger
              </Link>
              {isAdmin && (
                <Link to="/admin" onClick={() => setDropdownOpen(false)}>
                  Administrasjon
                </Link>
              )}
              <button onClick={handleLogout}>
                Logg ut
              </button>
            </div>
          )}
        </div>
      </nav>
      <main className="main-content">{children}</main>
    </div>
  );
}

export default Layout;
